import React from 'react';
import {
  StyledDropDown,
  appFormUtil
} from 'modules';
import * as ds from './dataService';


export type SelectSubAreaFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: keyof T;
  inputLabel?: string;
  disabled?: boolean;
};

export const FC = <T extends object>(props: SelectSubAreaFieldProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      inputLabel={props.inputLabel ? props.inputLabel : undefined}
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
      disabled={props.disabled}
    />
  );
};
